<div>
  <app-address-selector [(address)]="value" (addressChange)="save($event)"></app-address-selector>
</div>
